<form 
	class="two-factor-password-form" 
	(submit)="onSubmit($event)">
	<dx-form
		[formData]="formData"
		[disabled]="loading"
		[showColonAfterLabel]="true"
		[showRequiredMark]="false"
	>
		<dxi-item
			dataField="twoFactorCode"
			editorType="dxTextBox"
			[editorOptions]="{
				stylingMode: 'filled',
				placeholder: 'Kód',
				mode: 'password'
			}"
		>
		<dxi-validation-rule
			type="required"
			message="A kód kötelező"
		></dxi-validation-rule>
		<dxo-label [visible]="false"></dxo-label>
		</dxi-item>

		<dxi-item itemType="button">
			<dxo-button-options
				width="100%"
				type="default"
				[useSubmitBehavior]="true"
				[template]="'buttonTemplate'"
				[elementAttr]="{ class: 'submit-button' }"
			>
			</dxo-button-options>
		</dxi-item>

		<ng-container *dxTemplate="let item of 'buttonTemplate'">
			<span class="dx-button-text">
				<ng-container *ngIf="loading; else notLoading">
					<dx-load-indicator
						width="24px"
						height="24px"
						[visible]="true"
					></dx-load-indicator>
				</ng-container>
				<ng-template #notLoading>Tovább</ng-template>
			</span>
		</ng-container>
	</dx-form>
</form>
